const list = value => Array.isArray(value) ? value : value ? [value] : []
// 数据面板和属性面板共用原有开关；未设置时保留已有高级配置的显示方式。
export function chartVisibilitySettings (option = {}) {
  const custom = option.echartsOption && typeof option.echartsOption === 'object' ? option.echartsOption : {}
  return {
    titleShow: typeof option.titleShow === 'boolean' ? option.titleShow : list(custom.title).some(item => item && item.show !== false && !!(item.text || item.subtext)),
    legend: typeof option.legend === 'boolean' ? option.legend : list(custom.legend).some(item => item && item.show === true)
  }
}
// 显式的显示开关优先，刷新或高级 Option 合并都不能重新打开已关闭的标题/图例。
export function composeChartVisibility (generated, option = {}) {
  let result = generated
  for (const [key, field] of [['title', 'titleShow'], ['legend', 'legend']]) {
    if (typeof option[field] !== 'boolean') continue
    const current = generated[key], items = (list(current).length ? list(current) : [{}]).map(item => ({ ...item, show: option[field] }))
    result = { ...result, [key]: Array.isArray(current) ? items : items[0] }
  }
  return result
}
